import * as React from 'react';
import { Row } from 'antd';
import './PrivateDesktopLayout.scss';
import Header from '../../../../header/Header';
import Loading from '../../../../loading/Loading';
import Footer from '../../../../footer/Footer';

const PrivateDesktopLayout = (props) => {
  const { children } = props;

  return (
    <div className='private-layout'>
      <Header />
      <Row>
        <div className='container-content'>
          <Loading />
          {children}
        </div>
      </Row>
      <Footer />
    </div>
  );
};

export default PrivateDesktopLayout;
